/*
 * View for a list of topics
 */

define(["marionette", "./template/kbRoleListTemplate.html"], function (
  Marionette,
  KbRoleListLayout,
) {
  var KbRoleListView = {};

  KbRoleListView.kbRoleListLayout = Marionette.Layout.extend({
    template: KbRoleListLayout,
    triggers: {
      "click #addKbRole": "add:kbRole",
    },
    regions: {
      kbRoles: "#kbRolesList",
    },
  });

  return KbRoleListView;
});
